import type { AnnounceBannerItem } from "@/features/announce/api/announceClient";

export type AnnouncementBannerTarget = {
  kind: "detail";
  announcementId: number;
};

export function getAnnouncementBannerTarget(
  banner: Pick<AnnounceBannerItem, "id">,
): AnnouncementBannerTarget {
  return { kind: "detail", announcementId: banner.id };
}

interface AnnouncementBannerActions {
  openDesktop: (announcementId: number) => void;
  openMobileDetail: (announcementId: number) => void;
}

export function activateAnnouncementBanner(
  banner: Pick<AnnounceBannerItem, "id">,
  isDesktop: boolean,
  actions: AnnouncementBannerActions,
): void {
  const target = getAnnouncementBannerTarget(banner);
  if (isDesktop) {
    actions.openDesktop(target.announcementId);
    return;
  }
  actions.openMobileDetail(target.announcementId);
}
